import { render, staticRenderFns } from "./save_button_brigad_ajil_bair_zar.vue?vue&type=template&id=e794fb40&"
import script from "./save_button_brigad_ajil_bair_zar.vue?vue&type=script&lang=js&"
export * from "./save_button_brigad_ajil_bair_zar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports